import {
	DEFAULT_MAP_DIFFICULTIES,
	analyzeMapDifficulty,
	createDailyMapPack,
	createWeeklyMapPack,
	generateMapPack,
	summarizeDifficultyFactors,
} from "../../services/maps/proceduralMapService.js";

export const REFERENCE_MAPS = [
	{
		name: "Serpentine",
		desc: "Classic S-curve approach.",
		color: "#55d9ff",
		threat: "Balanced opener",
		path: [[-1, 1], [0, 1], [1, 1], [2, 1], [3, 1], [4, 1], [5, 1], [5, 2], [5, 3], [5, 4], [5, 5], [6, 5], [7, 5], [8, 5], [9, 5], [10, 5], [10, 4], [10, 3], [10, 2], [10, 1], [11, 1], [12, 1], [13, 1], [14, 1], [14, 2], [14, 3], [14, 4], [14, 5], [14, 6], [14, 7], [14, 8], [14, 9], [14, 10], [13, 10], [12, 10], [11, 10], [10, 10], [9, 10], [8, 10], [7, 10], [7, 9], [7, 8], [7, 7], [6, 7], [5, 7], [4, 7], [3, 7], [2, 7], [2, 8], [2, 9], [2, 10], [3, 10], [4, 10], [5, 10], [5, 11], [5, 12]],
	},
	{
		name: "Zigzag",
		desc: "Tight horizontal switchbacks.",
		color: "#ff6b58",
		threat: "High travel time",
		path: [[-1, 0], [0, 0], [1, 0], [2, 0], [3, 0], [4, 0], [5, 0], [6, 0], [7, 0], [8, 0], [9, 0], [10, 0], [11, 0], [12, 0], [13, 0], [14, 0], [15, 0], [16, 0], [17, 0], [18, 0], [19, 0], [19, 1], [19, 2], [18, 2], [17, 2], [16, 2], [15, 2], [14, 2], [13, 2], [12, 2], [11, 2], [10, 2], [9, 2], [8, 2], [7, 2], [6, 2], [5, 2], [4, 2], [3, 2], [2, 2], [1, 2], [0, 2], [0, 3], [0, 4], [1, 4], [2, 4], [3, 4], [4, 4], [5, 4], [6, 4], [7, 4], [8, 4], [9, 4], [10, 4], [11, 4], [12, 4], [13, 4], [14, 4], [15, 4], [16, 4], [17, 4], [18, 4], [19, 4], [19, 5], [19, 6], [18, 6], [17, 6], [16, 6], [15, 6], [14, 6], [13, 6], [12, 6], [11, 6], [10, 6], [9, 6], [8, 6], [7, 6], [6, 6], [5, 6], [4, 6], [3, 6], [2, 6], [1, 6], [0, 6], [0, 7], [0, 8], [1, 8], [2, 8], [3, 8], [4, 8], [5, 8], [6, 8], [7, 8], [8, 8], [9, 8], [10, 8], [11, 8], [12, 8], [13, 8], [14, 8], [15, 8], [16, 8], [17, 8], [18, 8], [19, 8], [19, 9], [19, 10], [18, 10], [17, 10], [16, 10], [15, 10], [14, 10], [13, 10], [12, 10], [11, 10], [10, 10], [10, 11], [10, 12]],
	},
	{
		name: "Spiral",
		desc: "Clockwise compression into the core.",
		color: "#e84dff",
		threat: "Central kill zone",
		path: [[-1, 0], [0, 0], [1, 0], [2, 0], [3, 0], [4, 0], [5, 0], [6, 0], [7, 0], [8, 0], [9, 0], [10, 0], [11, 0], [12, 0], [13, 0], [14, 0], [15, 0], [16, 0], [17, 0], [18, 0], [19, 0], [19, 1], [19, 2], [19, 3], [19, 4], [19, 5], [19, 6], [19, 7], [19, 8], [19, 9], [19, 10], [19, 11], [18, 11], [17, 11], [16, 11], [15, 11], [14, 11], [13, 11], [12, 11], [11, 11], [10, 11], [9, 11], [8, 11], [7, 11], [6, 11], [5, 11], [4, 11], [3, 11], [2, 11], [1, 11], [0, 11], [0, 10], [0, 9], [0, 8], [0, 7], [0, 6], [0, 5], [0, 4], [0, 3], [0, 2], [1, 2], [2, 2], [3, 2], [4, 2], [5, 2], [6, 2], [7, 2], [8, 2], [9, 2], [10, 2], [11, 2], [12, 2], [13, 2], [14, 2], [15, 2], [16, 2], [17, 2], [17, 3], [17, 4], [17, 5], [17, 6], [17, 7], [17, 8], [17, 9], [16, 9], [15, 9], [14, 9], [13, 9], [12, 9], [11, 9], [10, 9], [9, 9], [8, 9], [7, 9], [6, 9], [5, 9], [4, 9], [3, 9], [2, 9], [2, 8], [2, 7], [2, 6], [2, 5], [2, 4], [3, 4], [4, 4], [5, 4], [6, 4], [7, 4], [8, 4], [9, 4], [10, 4], [11, 4], [12, 4], [13, 4], [14, 4], [15, 4], [15, 5], [15, 6], [15, 7], [14, 7], [13, 7], [12, 7], [11, 7], [10, 7], [9, 7], [8, 7], [7, 7], [6, 7], [5, 7], [4, 7], [4, 6], [4, 5], [5, 5], [6, 5], [7, 5], [8, 5], [9, 5], [10, 5], [11, 5], [12, 5], [13, 5], [13, 6], [12, 6], [11, 6], [10, 6], [9, 6], [8, 6], [7, 6], [6, 6]],
	},
	{
		name: "Labyrinth",
		desc: "Dense maze with sudden turns.",
		color: "#7cf7d4",
		threat: "Split coverage checks",
		path: [[-1, 0], [0, 0], [1, 0], [2, 0], [3, 0], [3, 1], [3, 2], [3, 3], [3, 4], [2, 4], [1, 4], [0, 4], [0, 5], [0, 6], [0, 7], [0, 8], [1, 8], [2, 8], [3, 8], [3, 7], [3, 6], [4, 6], [5, 6], [6, 6], [6, 7], [6, 8], [6, 9], [6, 10], [7, 10], [8, 10], [9, 10], [9, 9], [9, 8], [9, 7], [9, 6], [9, 5], [9, 4], [10, 4], [11, 4], [12, 4], [12, 5], [12, 6], [12, 7], [12, 8], [13, 8], [14, 8], [15, 8], [15, 7], [15, 6], [15, 5], [15, 4], [15, 3], [15, 2], [16, 2], [17, 2], [18, 2], [18, 3], [18, 4], [18, 5], [18, 6], [18, 7], [18, 8], [18, 9], [18, 10], [17, 10], [16, 10], [15, 10], [15, 11], [15, 12]],
	},
	{
		name: "Fortress",
		desc: "Outer ring into an inner keep.",
		color: "#f8e45c",
		threat: "Final endurance run",
		path: [[-1, 0], [0, 0], [1, 0], [2, 0], [3, 0], [4, 0], [5, 0], [6, 0], [7, 0], [8, 0], [9, 0], [10, 0], [11, 0], [12, 0], [13, 0], [14, 0], [15, 0], [16, 0], [17, 0], [18, 0], [19, 0], [19, 1], [19, 2], [19, 3], [19, 4], [19, 5], [19, 6], [19, 7], [19, 8], [19, 9], [19, 10], [19, 11], [18, 11], [17, 11], [16, 11], [15, 11], [14, 11], [13, 11], [12, 11], [11, 11], [10, 11], [9, 11], [8, 11], [7, 11], [6, 11], [5, 11], [4, 11], [3, 11], [2, 11], [1, 11], [0, 11], [0, 10], [0, 9], [0, 8], [0, 7], [0, 6], [0, 5], [1, 5], [2, 5], [3, 5], [4, 5], [5, 5], [5, 4], [5, 3], [6, 3], [7, 3], [8, 3], [9, 3], [10, 3], [11, 3], [12, 3], [13, 3], [14, 3], [14, 4], [14, 5], [14, 6], [14, 7], [14, 8], [13, 8], [12, 8], [11, 8], [10, 8], [9, 8], [8, 8], [7, 8], [6, 8], [5, 8], [5, 9], [5, 10], [5, 11], [5, 12]],
	},
];

const ARCHETYPE_STYLE_BY_REFERENCE = {
	Serpentine: "swarm",
	Zigzag: "transit",
	Spiral: "folded",
	Labyrinth: "maze",
	Fortress: "fortress",
};

export const MAP_DIFFICULTY_FACTORS = {
	pathLength: "Short lanes are harder because towers get fewer firing cycles. Long lanes are easier because towers get more time on target.",
	turnCount: "Frequent turns break long uninterrupted firing lanes and raise strategy pressure.",
	foldContacts: "When path segments run near each other, splash, chain, and overlapping range zones get stronger, which lowers difficulty.",
	edgeRatio: "Edge-heavy routes reduce available build coverage and usually make the map harder.",
	centerPull: "Routes passing near the center give more tower positions meaningful coverage and tend to be easier.",
	coverage: "Higher near-path coverage means more useful tower cells, which reduces difficulty.",
	averageSegment: "Long straights make range planning easier. Tight short segments punish generic placement.",
};

export const REFERENCE_MAP_ANALYSIS = REFERENCE_MAPS.map((map) => {
	const metrics = analyzeMapDifficulty(map);
	return {
		...map,
		style: ARCHETYPE_STYLE_BY_REFERENCE[map.name] || "swarm",
		metrics,
		factors: summarizeDifficultyFactors(metrics),
	};
});

export const CAMPAIGN_MAP_BLUEPRINTS = REFERENCE_MAP_ANALYSIS.map((map, index) => ({
	id: `campaign-${index + 1}`,
	name: DEFAULT_MAP_DIFFICULTIES[index]?.name || `${map.name} Prime`,
	color: map.color,
	style: map.style,
	difficulty: map.metrics.difficulty,
	referenceName: map.name,
	referenceDifficulty: map.metrics.difficulty,
	referenceFactors: map.factors,
}));

export const DEFAULT_CAMPAIGN_MAP_SEED = "campaign-v2";

export const createCampaignMapPack = (seed = DEFAULT_CAMPAIGN_MAP_SEED) => generateMapPack({
	seed,
	difficulties: CAMPAIGN_MAP_BLUEPRINTS.map((blueprint) => ({
		id: blueprint.id,
		name: blueprint.name,
		color: blueprint.color,
		style: blueprint.style,
		difficulty: blueprint.difficulty,
	})),
});

export const MAPS = createCampaignMapPack();

export const MAP_ANALYSIS = MAPS.map((map, index) => ({
	index,
	name: map.name,
	style: map.style,
	targetDifficulty: map.targetDifficulty,
	metrics: map.metrics || analyzeMapDifficulty(map),
	factors: summarizeDifficultyFactors(map.metrics || analyzeMapDifficulty(map)),
	reference: {
		name: CAMPAIGN_MAP_BLUEPRINTS[index]?.referenceName,
		difficulty: CAMPAIGN_MAP_BLUEPRINTS[index]?.referenceDifficulty,
		factors: CAMPAIGN_MAP_BLUEPRINTS[index]?.referenceFactors,
	},
}));

export const TOTAL_GENERATED_MAPS = MAPS.length;

export { createDailyMapPack, createWeeklyMapPack };
